// src/components/common/Feedback/FeedbackPage.jsx
import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import FeedbackForm from './Feedbackform';

const FeedbackPage = () => {
  return (
    <Container
      maxWidth="xl"
      sx={{ mt: 4, mb: 4, display: 'flex', flexDirection: 'column', gap: 3 }}
    >
      {/* Header stays full width */}
      <Box>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 700, color: 'text.primary', letterSpacing: '-0.5px' }}
        >
          Platform Feedback
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Share your experience and help us improve the platform
        </Typography>
      </Box>

      {/* ✅ Constrain form to a reasonable width, centered */}
      <Box sx={{ maxWidth: 720, width: '100%' }}>
        <FeedbackForm />
      </Box>
    </Container>
  );
};

export default FeedbackPage;